module.exports = require("./lib/polyfill");



/*****************
 ** WEBPACK FOOTER
 ** /Users/spikelny/Desktop/projects/art/fastcash/~/babel-core/polyfill.js
 ** module id = 1
 ** module chunks = 0
 **/